const PREFIX = "API_";

/**
 * @name LOADING
 * @const
 * @description Loading.
 */
export const LOADING = PREFIX + "LOADING";

/**
 * @name SUCCESS
 * @const
 * @description Success.
 */
export const SUCCESS = PREFIX + "SUCCESS";

/**
 * @name ERROR
 * @const
 * @description Error
 */
export const ERROR = PREFIX + "ERROR";